import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ChatSuggestions from '@/components/feature/ChatSuggestions';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <ChatSuggestions />
    </>
  );
}